// extracted by mini-css-extract-plugin
export default {"cursorOuter":"Pz7v_","cursorInner":"SUS2k","hover":"YKbW3"};